import * as React from 'react';

import { AppBar, Toolbar, Typography } from '@mui/material';
import { ReservationState } from '@atom/ReservationState';
import { useNavigate } from 'react-router-dom';
import { useResetRecoilState, useRecoilValue } from 'recoil';
import { FacilityState } from '@atom/FacilityState';

const NoSignInAppBar = () => {
  const navigate = useNavigate();

  const resetReservation = useResetRecoilState(ReservationState);
  const facility = useRecoilValue(FacilityState);

  const toReturnHome = () => {
    resetReservation();
    navigate(`/c001/arealist?facilityId=${facility.facilityId}`);
    return undefined;
  };
return(
  <AppBar position="static">
    <Toolbar variant="dense">
      <Typography variant="h6" sx={{ color: 'white !important', cursor: 'pointer' }}onClick={toReturnHome}>
        passa予約
      </Typography>
    </Toolbar>
  </AppBar>
  )
};

export default NoSignInAppBar;
